import React from 'react';
import styles from './Step3Score.module.scss';
import posed from 'react-pose';
import classNames from 'classnames';

const delay = 1900;
const duration = 2000;

const Box = posed.div({
    enter: {
        y: 0,
        delay,
        transition: {ease: 'easeOut', duration},
    },
    exit: {
        y: '2em',
        delay: 0,
    },
});

const Opacity = posed.div({
    enter: {
        opacity: 1,
        delay,
        transition: () => ({
            type: 'keyframes',
            values: [0, 1, 1, 0],
            times: [0, 0.3, 0.7, 1],
            duration,
        }),
    },
    exit: {
        opacity: 0,
    },
});

export default function Step3Score({className}) {
    return (
        <Box className={classNames(className, styles.score)}>
            <Opacity>+10 pts.</Opacity>
        </Box>
    );
}
